import Vue from "vue";
import GraphHelper from "@/helpers/utilities/GraphHelper";
import UserExtension from "@/models/extensions/education/UserExtension";
import apiGraph from "@/helpers/api/apiGraph";
import apiSkobo from "@/helpers/api/apiSkobo";
import { useSectionsStore } from "@/stores/sections";
import { useSettingsStore } from "@/stores/settings";

export const institution_state = {
  usersProfilePictures: {},
  profilePictures: {},
  allOnInstitution: []
};

export const institution_actions = {
  /**
   *
   * @param { Array } userList
   * @returns
   */

  loadProfilePicturesFromList(userList) {
    return new Promise((resolve, reject) => {
      const requestForUsersNotInState = userList
        .filter(u => u.extSysApiUserId && !this.usersProfilePictures[u.extSysApiUserId])
        .map(u => {
          Vue.set(this.usersProfilePictures, u.extSysApiUserId, null);
          return UserExtension.generateGraphRequestFromUser(u);
        });

      if (requestForUsersNotInState.length === 0) {
        resolve();
        return;
      }

      GraphHelper.makeBatchRequest(requestForUsersNotInState)
        .then(results => {
          results.map(u => {
            if (u.status === 200) {
              var url = "data:" + u.headers["Content-Type"] + ";base64," + u.body;

              fetch(url).then(res =>
                res.blob().then(blob => {
                  const url = window.URL.createObjectURL(blob);
                  this.usersProfilePictures[u.id] = url;
                })
              );
            }
          });

          resolve();
        })
        .catch(error => {
          userList.map(u => {
            delete this.loadProfilePicture[u.extSysApiUserId];
          });
          reject(error.message);
        });
    });
  },

  async loadProfilePicture(person) {
    if (!person || (!person.extSysApiUserId && !person.emailSchoolAddress)) {
      return;
    }

    if (!person.extSysApiUserId) {
      let personFromState;

      const sectionsStore = useSectionsStore();
      sectionsStore.peopleInMySections.find(p => p.emailSchoolAddress === person.emailSchoolAddress);

      if (!personFromState) {
        await this.loadAllPeopleOnInstitution();
        personFromState = this.allOnInstitution.find(p => p.emailSchoolAddress === person.emailSchoolAddress);
      }

      if (personFromState) {
        person.extSysApiUserId = personFromState.extSysApiUserId;
      } else {
        person.extSysApiUserId = person.emailSchoolAddress;
      }
    }

    if (Object.hasOwn(this.usersProfilePictures, person.extSysApiUserId)) {
      try {
        const response = await apiGraph.get(`/users/${person.extSysApiUserId}/photos/48x48/$value`, {
          responseType: "blob"
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const testImg = new Image();
        testImg.onload = () => {
          Vue.set(this.usersProfilePictures, person.extSysApiUserId, url);
        };
        testImg.onerror = () => {
          setTimeout(() => {
            /* TIL KATE
            Dispatch er Vuex sprog - her kalder du bare funktionen længere oppe med this.loadProfilePicture
            */
            //dispatch("loadProfilePicture", person);
          }, 3000);
        };
        testImg.src = url;
      } catch (e) {
        if (e.response && e.response.status === 401) {
          // If not authorized, try again in a few seconds
          setTimeout(() => {
            /* TIL KATE
            Dispatch er Vuex sprog - her kalder du bare funktionen længere oppe med this.loadProfilePicture
            */
            //dispatch("loadProfilePicture", person);
          }, 3000);
        } else {
          // user has no image
          Vue.set(this.usersProfilePictures, person.extSysApiUserId, null);
        }
      }
    }
  },

  async loadAllPeopleOnInstitution() {
    if (this.allOnInstitution && this.allOnInstitution.length > 0) {
      return;
    }

    const studentsResponse = await apiSkobo.get("/Institution/Member/Search/Student");
    const teachersResponse = await apiSkobo.get("/Institution/Member/Search/Teacher");
    const allPeople = studentsResponse.data.concat(teachersResponse.data);

    const allPeopleDistinct = [];
    const idMap = new Map();

    for (const item of allPeople) {
      if (!idMap.has(item.userId)) {
        idMap.set(item.userId, true);
        allPeopleDistinct.push(item);
      }
    }

    const userForStore = allPeopleDistinct.map(p => ({
      name: {
        firstName: p.firstName,
        lastName: p.lastName,
        name: p.displayName,
        title: p.title
      },
      emailSchoolAddress: p.emailSchoolAddress,
      extSysApiUserId: p.extSysApiUserId,
      userId: p.userId,
      roles: p.roles,
      identifier: p.identifier
    }));
    const settingsStore = useSettingsStore();
    userForStore.sort((a, b) => a.name.name.localeCompare(b.name.name, settingsStore.language));
    this.allOnInstitution = userForStore;
  },

  async loadPersonFromName({ commit }, { name }) {
    const response = await apiGraph.get(
      `https://graph.microsoft.com/v1.0/users?$count=true&$search="displayName:${name}"`,
      {
        headers: { ConsistencyLevel: "eventual" }
      }
    );

    response.data.value.forEach(v => {
      if (!this.allOnInstitution.find(a => a.extSysApiUserId === v.extSysApiUserId)) {
        this.allOnInstitution.push(v);
      }
      commit("loadPersonFromName", {
        emailSchoolAddress: v.mail,
        extSysApiUserId: v.id,
        name: {
          firstName: v.givenName,
          lastName: v.surname,
          name: v.displayName
        },
        roles: "student"
      });
    });
  }
};

export const institution_getters = {
  pictures: state => state.usersProfilePictures,
  picture: state => identifier => {
    if (!identifier) {
      return "";
    }

    if (state.usersProfilePictures && state.usersProfilePictures[identifier]) {
      return state.usersProfilePictures[identifier];
    }

    if (identifier.indexOf("@") > -1) {
      let person = state.allOnInstitution.find(p => p.emailSchoolAddress === identifier);

      if (!person) {
        person = state.allOnInstitution.find(p => p.emailSchoolAddress === person.emailSchoolAddress);
      }

      if (person && person.extSysApiUserId) {
        return state.usersProfilePictures[person.extSysApiUserId];
      }
    } else {
      let person = state.allOnInstitution.find(p => p.extSysApiUserId === identifier);

      if (person && person.emailSchoolAddress) {
        return state.usersProfilePictures[person.emailSchoolAddress];
      }
    }

    return null;
  },
  allStudents: state => state.allOnInstitution.filter(p => p.roles.indexOf("student") > -1),
  allTeachers: state => state.allOnInstitution.filter(p => p.roles.indexOf("teacher") > -1),
  all: state => state.allOnInstitution,
  fromId: state => userId => state.allOnInstitution.find(p => p.userId === userId),
  fromExternalApiUserId: state => extSysApiUserId =>
    state.allOnInstitution.find(p => p.extSysApiUserId === extSysApiUserId),
  fromEmail: state => email => {
    state.allOnInstitution.find(
      p => p.emailSchoolAddress && p.emailSchoolAddress.toLowerCase() === email.toLowerCase()
    );
  },

  getPersonFromIdentifier: state => identifier => {
    const person = state.allOnInstitution.find(p => p.identifier.toLowerCase() === identifier);

    return person;
  },
  fromName: state => name =>
    state.allOnInstitution.filter(p => p.name && p.name.name.toLowerCase() === name.toLowerCase())
};
